<template>
  <div class="wrapper">
    <div class="container-fluid reports-body ai-reports-menu">
      <div class="col" style="padding: 0;">
        <div class="row no-gutters">
          <div class="col-12">
            <dashboard-bar refreshButton>
              <div slot="menu-reports" style="display: flex;">
                <span style="margin-top: 7px; margin-right: 10px;">
                  <b>{{ this.$t('reports.subTitle') }}:</b>
                </span>
                <b-form-select
                  v-model="selected"
                  :options="options"
                ></b-form-select>
              </div>
            </dashboard-bar>
          </div>
        </div>
      </div>
    </div>
    <div class="col-12 p-0 mb-3">
      <summarization v-if="selected === 'Sumarização'" />
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { mapFields } from 'vuex-map-fields';
import dashboardBar from '@/components/molecules/dashboard-bar';
import ReportsEmotionCards from '@/components/molecules/reports-emotion-cards';
import summarization from '@/components/organisms/reports/ai-analysis/ai-summarization-reports/summarization';
import api from '@/services/api';
import EventBus from '../../../../../eventBus';

export default {
  name: 'Reports',
  components: {
    dashboardBar,
    ReportsEmotionCards,
    summarization,
  },
  computed: {
    ...mapState('authentication', ['userProfile']),
    ...mapFields('settings', ['country']),
    ...mapState('companies', ['myMetric']),
  },
  watch: {
    selected: async function watchSelected(value) {
      EventBus.$emit('iaReport', value);
      // EventBus.$emit('sendSelection', value);
    },

    country: async function watchCountry() {
      await this.getReportsMenu();
    },

    myMetric: async function watchMyMetric() {
      await this.getReportsMenu();
      this.getReportOptionName();
    },

    $i18n: function watchLanguage() {
      this.getReportOptionName();
    },
  },
  data: () => ({
    selected: null,
    userAuth: null,
    options: [],
  }),

  methods: {
    async getReportsMenu() {
      let { data } = await api.get(`/report-companies`, {
        headers: {
          'x-access-token': this.userAuth.token,
        },
        params: {
          companyId: this.userAuth.companyId,
        },
      });
      const reportCompany = data;
      data = await api.get(`/reports`, {
        headers: {
          'x-access-token': this.userAuth.token,
        },
      });

      const reportProfileData = await api.get('/get-profile-report', {
        headers: {
          'x-access-token': this.userAuth.token,
        },
      });

      const reportProfile = reportProfileData.data.reportsProfile;
      const reports = data.data.filter((item) => item.reportType === 'ia');

      this.options = [{ value: null, text: this.$t('reports.selectReport') }];
      for (let i = 0; i < reports.length; i += 1) {
        const reportName = this.getReportOptionName(reports[i].reportName);
        this.options.push({
          value: reports[i].reportName,
          text: reportName ? reportName : reports[i].reportName,
        });
      }
    },

    getReportOptionName(reportKey) {
      const reportNames = this.$i18n.messages[this.$i18n.locale].reports
        .reportTitles;

      for (let i = 0; i < reportNames.length; i += 1) {
        if (reportNames[i].key === reportKey) {
          if (this.myMetric.indexOf('nps') !== -1) {
            return reportNames[i].value;
          } else if (this.myMetric.indexOf('ces') !== -1) {
            return reportNames[i].cesValue;
          } else if (this.myMetric === 'csat-1-5') {
            return reportNames[i].csatValue;
          } else if (this.myMetric === 'csat-1-5(media)' || this.myMetric === 'csat-0-10(media)') {
            return reportNames[i].csatValueAverage;
          } else if (this.myMetric === '5-stars') {
            return reportNames[i].fiveStarsValue;
          } else if (this.myMetric === 'like-dislike') {
            return reportNames[i].likeDislikeValue;
          }
        }
      }

      return null;
    },
  },

  async created() {
    this.userAuth = JSON.parse(localStorage.getItem('_indecx'));

    if (!this.userProfile.permissions.reports.menu) {
      this.$router.push(`/dashboard/${this.userAuth.companyId}`);
    }
  },

  async mounted() {
    await this.getReportsMenu();
    // this.selected = null;
    this.selected = 'Sumarização';

    await this.getReportOptionName();
  },
};
</script>

<style lang="scss" scoped>
@import '@/themes/default/variables.scss';
@import '@/themes/default/placeholders.scss';
@import '@/themes/default/mixins.scss';

.wrapper {
  width: 100%;
  .reports-body {
    // @include bg-color($white);
    @each $i in $directions {
      @extend %half-padding-#{$i};
    }
    .report {
      background-color: $white;
      padding: 10px;
    }
  }
}
.ai-reports-menu {
  padding-bottom: 0px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/organisms/reports/ai-analysis/ai-summarization-reports/index.vue